<template>
  <nav-bar title="开拓用户" />
  <Content :bottom="0">
    <Loading
      v-if="showLoading"
      :isLoading="isLoading"
      @reload="getDataLoading"
    />
    <UserMap v-if="!isLoading" :point="point" />
    <van-cell-group class="group" title="基本信息">
      <van-cell title="用户名" :value="userInfo.companyName" />
      <van-cell title="用户名代码" :value="userInfo.creditNo || '暂无'" />
      <van-cell title="联系人" :value="userInfo.userName" />
      <van-cell title="联系电话" :value="userInfo.phoneNum" />
      <van-cell title="街道" :value="userInfo.streetName || '暂无'" />
      <van-cell title="地址" :value="userInfo.address" />
    </van-cell-group>
    <van-field
      class="input"
      v-model="weight"
      type="number"
      label="日使用量"
      placeholder="请输入日使用量"
      input-align="right"
    />
    <div class="btn">
      <van-button
        type="primary"
        block
        :loading="loading"
        :disabled="loading"
        @click="handleBtnClick"
        >提交</van-button
      >
    </div>
  </Content>
</template>

<script>
import { Toast } from 'vant'
import { getUserdetail, updateWeightById } from '@/api/cuser'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { useSubmit } from '@/hooks/useSubmit'
import { reactive, ref } from 'vue'
export default {
  name: 'DevelopUsers', // 开拓用户
  props: ['userId'],
  setup(props) {
    const userInfo = ref({})
    const point = reactive({
      longitude: '',
      latitude: ''
    })
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(
      getUserdetail,
      data => {
        userInfo.value = data
        point.longitude = data.longitude
        point.latitude = data.latitude
      },
      props.userId
    )
    getDataLoading()

    const weight = ref('')
    const params = {
      userId: props.userId,
      weight: ''
    }
    const { loading, onSubmit } = useSubmit(updateWeightById, params, () => {})
    const handleBtnClick = () => {
      if (weight.value) {
        params.weight = weight.value
        onSubmit()
      } else {
        Toast('请输入日使用量')
      }
    }

    return {
      getDataLoading,
      showLoading,
      isLoading,
      point,
      userInfo,
      weight,
      onSubmit,
      handleBtnClick,
      loading
    }
  }
}
</script>

<style lang="scss" scoped>
.input {
  margin-top: 16px;
}
.btn {
  margin: 16px;
}
</style>
